// extracted by mini-css-extract-plugin
module.exports = {"ChooseLocationWrapper":"ChooseLocation_ChooseLocationWrapper__36DJU","ChosenAddress":"ChooseLocation_ChosenAddress__2Iup7","RemoveAddress":"ChooseLocation_RemoveAddress__3w00c"};